import { MediaItem } from '@/types/greenroom/media.types';
import isVideo from './is-video';
import getVideoDuration from './get-video-duration';
import { ResourcePool } from './use-resource-pool';

const getShotDuration = async (
  media: MediaItem[],
  mediaId: number | null,
  resourcePool?: ResourcePool | null,
  oldDuration: number = 0
) => {
  const mediaItem = media.find((med: MediaItem) => med.id === mediaId);

  if (mediaItem) {
    const pages = mediaItem.media_data.image_array;
    let suggestedDuration = 0;
    const video = document.createElement('video');
    video.preload = 'metadata';
    video.crossOrigin = 'anonymous';
    for (let i = 0; i < pages.length; i += 1) {
      const page = pages[i];
      if (isVideo(page) && !!resourcePool) {
        const videoDuration = await getVideoDuration(page, mediaItem.type, video, resourcePool);
        suggestedDuration += videoDuration;
      }
    }

    if (suggestedDuration) {
      // max duration is 99 minutes
      return suggestedDuration;
    }
    return oldDuration;
  }
  return oldDuration;
};

export default getShotDuration;
